import type { ReactNode } from 'react';
import { useDisplayScale } from '../utils/hooks/useDisplayScale';

type Props = {
  children: ReactNode;
};

/** Applies presentation / large-monitor UI scale globally. */
export default function DisplayScaleProvider({ children }: Props) {
  useDisplayScale();
  return children;
}
